import { Modal, Table } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { Row, Col } from "antd";
import { Scrollbars } from "react-custom-scrollbars";
import { shortcutData, shortcutColumns } from "./columnDefinitions";

const ShortcutsModal = ({
  shortcutsListModalOpen,
  setShortcutsListModalOpen,
  shortcutsRef,
  selectedRowIndex,
}) => {
  return (
    <Modal
      title={
        <Row>
          <Col span={12}>
            <p className="shortcutsModalTitle">Keyboard Shortcuts</p>
          </Col>
          <Col span={12}>
            <p style={{ float: "right", marginBottom: "0px" }}>
              <CloseOutlined onClick={() => setShortcutsListModalOpen(false)} style={{ fontSize: 18, color: "#000000" }} />
            </p>
          </Col>
        </Row>
      }
      closable={false}
      onCancel={() => setShortcutsListModalOpen(false)}
      footer={null}
      styles={{ body: { padding: 0 } }}
      open={shortcutsListModalOpen}
      className="customModal"
      width="40%"
    >
      <Scrollbars style={{ height: "60vh" }} ref={shortcutsRef}>
        <div style={{ padding: "10px 5px" }}>
          <Table
            dataSource={shortcutData}
            columns={shortcutColumns}
            pagination={false}
            rowKey={(record) => record.action}
            className="shortcutTable"
            rowClassName={(record, index) => (index === selectedRowIndex ? "selectedRow" : "")}
          />
        </div>
      </Scrollbars>
    </Modal>
  );
};

export default ShortcutsModal;
